import { Breed } from './../_models/breed';
import { Pelage } from './../_models/pelage';
import { Species } from './../_models/species';
import { AngularFirestore } from 'angularfire2/firestore';
import { Injectable, Optional, InjectionToken, Inject } from '@angular/core';
import { Gender } from '../_models/gender';
import { Converters } from '../_utilities/converters';

export const MODULE_CONFIG = new InjectionToken<any>('');

@Injectable({
  providedIn: 'root'
})
export class CachedDataService {

  private _petsData: any = {
    gender: [
      { uuid: null, name: 'Selecione um gênero' },
      { uuid: 'f', name: 'Fêmea' },
      { uuid: 'm', name: 'Macho' },
    ],
    species: [
      { uuid: 'canino', name: 'Canino', breeds: [] },
      { uuid: 'felino', name: 'Felino', breeds: [] },
    ],
    pelage: [
      { uuid: 'sp', name: 'Sem Pêlo' },
      { uuid: 'pc', name: 'Pêlo Curto' },
      { uuid: 'pl', name: 'Pêlo Longo' },
      { uuid: 'pd', name: 'Pêlo Duro' },
    ]
  };

  constructor(
    @Inject(MODULE_CONFIG) private config: any,
    private _firestore: AngularFirestore,
  ) {
    if (config) { }

    const that = this;

    this._petsData.species.forEach((element, index) => {
      const specieDoc = this._firestore
        .collection('species')
        .doc(element.uuid);

      specieDoc.ref.get().then(doc => {
        if (doc.exists) {
          specieDoc.collection('breeds').ref.orderBy('name', 'asc').get().then(result => {
            result.forEach(function (item) {
              that._petsData.species[index].breeds.push(new Breed({ uuid: item.id, ...item.data() }));
            });
          });
        }
      });
    });
  }

  get genderList(): Array<Gender> {
    return Converters.ConvertGender(this._petsData.gender);
  }

  get speciesList(): Array<Species> {
    return Converters.ConvertSpecies(this._petsData.species);
  }

  get pelageList(): Array<Pelage> {
    return Converters.ConvertPelage(this._petsData.pelage);
  }

}
